module.exports = __webpack_public_path__ + "src/assets/games/9/196.jpg";